import  DragSlider  from '../utils/components/dragSlider';
import {BulbModule} from '../core/bulbModule';
import emitter from 'tiny-emitter/instance';
import { throttle } from 'throttle-debounce';


export default class extends BulbModule {
  constructor(m)
  {
    //console.debug('Slider: Constructor')
    super(m);
    this.btnLeft = this.el.querySelector("[data-dragSlider='btnLeft']")
    this.btnRight = this.el.querySelector("[data-dragSlider='btnRight']")
    console.log(this.btnLeft, this.btnRight)
    console.log('new Slider constr')
  }


  init()
  {
    console.debug('Slider: Constructor')

    this.drag = new DragSlider(this.el, {
      inertiaSpeed : 1,
      getSlide : false,
      draggableBar : false,
      arrowBtnDirection: true
    });

    this.handleResize = () => {
      this.onResize()
    }
    this.debouncedHandleResize = throttle( 50,false, this.handleResize);


    this.bindEvents();
    this.onResize();

    this.bOn('onEnterViewport', this.play.bind(this))
    this.bOn('onExitViewport', this.pause.bind(this))

    //const drag = new DragSlider('.drag','.drag-slide');
  }

  bindEvents()
  {
    window.addEventListener('resize', this.debouncedHandleResize, false);

    this.btnRight.addEventListener('click', () => {
      this.drag.moveTo('right')
    })
    this.btnLeft.addEventListener('click', () => {
      this.drag.moveTo('left')
    })

    emitter.on('dragSlider::limit',(el, direction) => {
      if(direction === 'left') {
        el.querySelector("[data-dragSlider='btnLeft']").style.opacity = '0.3'
        el.querySelector("[data-dragSlider='btnRight']").style.opacity = '1'
      } else {
        el.querySelector("[data-dragSlider='btnRight']").style.opacity = '0.3'
        el.querySelector("[data-dragSlider='btnLeft']").style.opacity = '1'
      }
    });

    emitter.on('dragSlider::noLimit',(el) => {
      el.querySelector("[data-dragSlider='btnLeft']").style.opacity = '1'
      el.querySelector("[data-dragSlider='btnRight']").style.opacity = '1'
    });
  }

  pause()
  {
    this.drag.pause();
  }

  play()
  {
    this.drag.play();
  }

  /**
   * Event lancé a chque resize (il est throttlé)
   */
  onResize(){
    // calcul du padding
    let offsetLeft = document.querySelector('.footer__logo').getBoundingClientRect().left;
      if(this.el.querySelector('article:first-child')){
        this.el.querySelector('article:first-child').style.marginLeft = offsetLeft + 'px';
      }

  }


  destroy()
  {
    super.destroy()
    emitter.off('dragSlider::limit');
    emitter.off('dragSlider::noLimit');
    window.removeEventListener('resize', this.debouncedHandleResize, false)
    // this.btnLeft.removeEventListener('click', this.dragTo('left'))
    // this.btnRight.removeEventListener('click', this.dragTo('right'))
  }
}





// WEBPACK FOOTER //
// ./scripts/modules/newsSlider.js